import { useAppSelector } from '../../store/hooks'
import { selectAccountId } from '../../store/auth/authSlice'
import { useGetAccountQuery } from '../../store/accountUserSettings/accountUserSettings'

export const useConsentManualConfigs = () => {
  const accountId = useAppSelector(selectAccountId)
  const { data: account, isFetching } = useGetAccountQuery({ accountId }, { refetchOnMountOrArgChange: true })

  const complianceConfig = account?.data.effectiveConfig.complianceConfig
  const userConsentManualConfigs = complianceConfig?.userConsentManualConfigs

  const evidenceUpload = userConsentManualConfigs?.evidenceUpload ?? null
  const commentUpload = userConsentManualConfigs?.commentUpload ?? null
  const userConsentManualOverride = complianceConfig?.userConsentManualOverride ?? false
  const consentWarningText = userConsentManualConfigs?.consentWarningText ?? null

  return {
    evidenceUpload,
    commentUpload,
    userConsentManualOverride,
    consentWarningText,
    isFetching,
  }
}
